<template>
    <v-container fluid>
    
    <v-card flat class="rounded-lg py-2" height="100%">
        <v-icon
            size = "30"
            style="cursor: pointer;float:left"
            class="ml-2 mt-1 mr-5"
            @click="sidebar.open=!sidebar.open"
        >{{sidebar.icon}}</v-icon>
        <div class="rounded-lg ml-2 pageTitle" style="width: 250px;float:left">
            <v-toolbar-title style="font-weight:bold;">模型管理</v-toolbar-title>
        </div>
        <br/>

        <div class="rowDiv contentCenter px-2" v-if="tables.mf_info">
            <v-toolbar-title class="ml-2" style="font-weight:bold;">{{tables.mf_info.title}}</v-toolbar-title>
            <div>
                <v-btn v-if="false" depressed  color="success" class="btn_fontSize ml-2" @click="() => {}">匯出</v-btn>
            </div>

            <v-spacer>
            </v-spacer>
            <div class="text-center mr-5">
                <v-pagination
                    circle
                    v-model="tables.mf_info.page"
                    :length="tables.mf_info.pageCount"
                    total-visible=7
                ></v-pagination>
            </div>
            <v-divider
            class="tableDivider mr-5"
            vertical
            inset
            >
            </v-divider>
            <div class="text-center mr-5 contentCenter">共{{tables.mf_info.total}}筆</div>
            <!-- 每頁顯示筆數 -->
            <div style="width:180px">
                <v-select
                    :items="tables.mf_info.rowsList"
                    outlined
                    class="rounded-lg"
                    dense
                    v-model="tables.mf_info.rows"
                    hide-details
                    prefix="每頁顯示"
                    suffix="筆"
                >
                </v-select>
            </div>
        </div>
        <v-data-table
            class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
            hide-default-footer
            :items="tables.mf_info.data"
            :headers="tables.mf_info.headers"
            hide-default-header
            v-if="tables.mf_info"
            :loading="tables.mf_info.isLoading"
        >
            <template v-slot:header>
                <thead>
                <tr>
                    <th
                        class="greyTh"
                        v-for="header in tables.mf_info.headers"
                        :key="header.value"
                    >
                    <div
                        :style="'width:'+header.width+'px'"
                        @click="changeSort(header, tables.mf_info)"
                        class="sortableThDiv"
                    >
                        <div class="sortableThDivText">{{header.text}}</div>
                        <div v-if="header.sortable&&tables.mf_info.sortItem===header.value">
                            <v-icon v-if="tables.mf_info.sortOrder">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                        </div>
                    </div>
                    </th>
                </tr>
                </thead>
            </template>
            <template v-slot:item="{ item }">
                <tr>
                <td v-for="header in tables.mf_info.headers"
                    :key="header.value"
                    class="tableTD"
                    @click="openMFDialog(item)"
                >
                    
                    <div v-if ="header.value === 'status'">
                        <v-icon
                            size = "25"
                        >{{GetStatusIcon(item)}}</v-icon>
                        {{GetStatusExtensionDesc(item)}}
                    </div>
                    <div v-else-if ="header.value === 'collect_dt'">
                        {{item[header.value].replaceAll(':','').replaceAll(' ','').replaceAll('-','')}}
                    </div>
                    
                    <div v-else>
                    {{item[header.value]}}
                    </div>
                </td>
                </tr>
            </template>
            <template v-slot:no-data>
                no data available
            </template>
        </v-data-table>
        <br/>
        
        <div class="rowDiv contentCenter px-2 mt-5" v-if="tables.sd_info">
            <v-toolbar-title class="ml-2" style="font-weight:bold;">{{tables.sd_info.title}}</v-toolbar-title>
            <div>
                <v-btn v-if="false" depressed  color="success" class="btn_fontSize ml-2" @click="() => {}">匯出</v-btn>
            </div>

            <v-spacer>
            </v-spacer>
            <div class="text-center mr-5">
                <v-pagination
                    circle
                    v-model="tables.sd_info.page"
                    :length="tables.sd_info.pageCount"
                    total-visible=7
                ></v-pagination>
            </div>
            <v-divider
            class="tableDivider mr-5"
            vertical
            inset
            >
            </v-divider>
            <div class="text-center mr-5 contentCenter">共{{tables.sd_info.total}}筆</div>
            <!-- 每頁顯示筆數 -->
            <div style="width:180px">
                <v-select
                    :items="tables.sd_info.rowsList"
                    outlined
                    class="rounded-lg"
                    dense
                    v-model="tables.sd_info.rows"
                    hide-details
                    prefix="每頁顯示"
                    suffix="筆"
                >
                </v-select>
            </div>
        </div>
        <v-data-table
            class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
            hide-default-footer
            :items="tables.sd_info.data"
            :headers="tables.sd_info.headers"
            hide-default-header
            :items-per-page="tables.sd_info.rows"
            v-if="tables.sd_info"
            :loading="tables.sd_info.isLoading"
        >
            <template v-slot:header>
                <thead>
                    <tr>
                        <th
                            class="greyTh"
                            v-for="header in tables.sd_info.headers"
                            :key="header.value"
                        >
                            <div
                                :style="'width:'+header.width+'px'"
                                @click="changeSort(header, tables.sd_info)"
                                class="sortableThDiv"
                            >
                                <div class="sortableThDivText">
                                    {{header.text}}
                                </div>
                                <div v-if="header.sortable&&tables.sd_info.sortItem===header.value">
                                    <v-icon v-if="tables.sd_info.sortOrder">mdi-chevron-down</v-icon>
                                    <v-icon v-else>mdi-chevron-up</v-icon>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
            </template>
            <template v-slot:item="{ item }">
                <tr>
                    <td v-for="header in tables.sd_info.headers"
                        :key="header.value"
                        class="tableTD"
                    >
                        <div v-if ="header.value === 'func'">
                            <div>
                                <v-btn class="btn_fontSize"
                                    depressed 
                                    color="success" 
                                    v-show="item.status == -1 || item.status == 0 || item.status == 3"
                                    @click="openSDDialog(item)">進行資料採集</v-btn>
                            </div>
                        </div>
                        <div v-if ="header.value === 'status'">
                            {{status_dic_2.find(s=>s.key == item[header.value]).value}}
                        </div>
                        <div v-else>
                            {{item[header.value]}}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-slot:no-data>no data available</template>
        </v-data-table>

        <!-- 搜尋 sidebar -->
        <v-navigation-drawer
            app
            clipped
            class="rounded-lg mt-3 ml-1"
            :width="sidebar.width"
            height="850"
            elevation="10"
            permanent
            v-show="sidebar.open"
        >
            <div class="rowDiv">
                <v-card-title v-if="sidebar.open" class="headline font-weight-bold">篩選條件</v-card-title>
                <v-spacer>
                </v-spacer>
            </div>
            <v-divider></v-divider>
            <div v-if="sidebar.open">
                <v-card-text style="height:50px;" class="searchTitle">{{tables.mf_info.title}} <v-btn @click="reset_search_mf_info" small depressed class="primary mt-n1">重設</v-btn></v-card-text>
                <v-card-title style="height:50px;" class="searchTitle">標的物編號</v-card-title>
                <div style="width:220px; height:30px" class="ml-4">
                    <v-text-field
                        v-model="tables.mf_info.search.site_id.value"
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </div>
                <v-card-title style="height:50px;" class="searchTitle">設備編號</v-card-title>
                <div style="width:220px; height:30px" class="ml-4">
                    <v-text-field
                        v-model="tables.mf_info.search.device_id.value"
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </div>
                <v-card-title style="height:50px;" class="searchTitle">設備MAC</v-card-title>
                <div style="width:220px; height:30px" class="ml-4">
                    <v-text-field
                        v-model="tables.mf_info.search.device_mac.value"
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </div>
                <v-card-title style="height:50px;" class="searchTitle">狀態</v-card-title>
                <div style="width:220px; height:30px" class="ml-4 mb-4">
                    <v-autocomplete
                        v-model="tables.mf_info.search.status.value"
                        :items="status_dic"
                        item-text="value"
                        item-value="key"
                        required
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                        clearable
                    ></v-autocomplete>
                </div>

                <v-divider></v-divider>
                <v-card-text style="height:50px;" class="searchTitle">{{tables.sd_info.title}} <v-btn @click="reset_search_sd_info" small depressed class="primary mt-n1">重設</v-btn></v-card-text>
                <v-card-title style="height:50px;" class="searchTitle">標的物編號</v-card-title>
                <div style="width:220px; height:30px" class="ml-4">
                    <v-text-field
                        v-model="tables.sd_info.search.site_id.value"
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </div>
                <v-card-title style="height:50px;" class="searchTitle">設備編號</v-card-title>
                <div style="width:220px; height:30px" class="ml-4">
                    <v-text-field
                        v-model="tables.sd_info.search.device_id.value"
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </div>
                <v-card-title style="height:50px;" class="searchTitle">設備MAC</v-card-title>
                <div style="width:220px; height:30px" class="ml-4">
                    <v-text-field
                        v-model="tables.sd_info.search.device_mac.value"
                        class="rounded-lg"
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                </div>
            </div>
        </v-navigation-drawer>

        <!-- 模型管理 dialog -->
        <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.mf_info.dialogAdd" persistent>
            <v-card>
                <v-card-title class="headline justify-center font-weight-bold">模型控制管理</v-card-title>
                <v-card-text>

                <div class="mt-5">
                    <v-form ref="ModelManagement">
                    <div class="rowDiv contentCenter">
                        <div style="width:200px">
                            <v-text-field
                                label="標的物編號"
                                v-model="tables.mf_info.SelectedData.site_id"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                        </div>
                        <div style="width:400px" class="ml-2">
                            <v-text-field
                                label="標的物名稱"
                                v-model="tables.mf_info.SelectedData.site_nm"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="rowDiv contentCenter mt-5">
                        <div style="width:200px">
                            <v-text-field
                                label="設備MAC"
                                v-model="tables.mf_info.SelectedData.device_mac"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                disabled
                            ></v-text-field>
                        </div>
                        <div style="width:400px" class="ml-2">
                            <v-text-field
                                label="設備編號"
                                v-model="tables.mf_info.SelectedData.device_id"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="rowDiv contentCenter mt-5">
                        <div style="width:200px">
                            <v-text-field
                                label="頻道"
                                v-model="tables.mf_info.SelectedData.channel"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                disabled
                            ></v-text-field>
                        </div>
                        <div style="width:400px" class="ml-2">
                            <v-text-field
                                label="設備名稱"
                                v-model="tables.mf_info.SelectedData.device_nm"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            >
                            </v-text-field>
                        </div>
                    </div>
                    <div class="rowDiv contentCenter mt-5">
                        <div style='width:200px;'>
                            <v-label v-if="tables.mf_info.SelectedData.cancel_dt!==null">已取消</v-label>
                            <v-label v-else-if="tables.mf_info.SelectedData.finish_dt!==null">完成模型更新</v-label>
                            <v-label v-else-if="tables.mf_info.SelectedData.uploaded_dt!==null">等待更新完成</v-label>
                            <v-label v-else-if="tables.mf_info.SelectedData.publish_dt!==null">等待模型上傳</v-label>
                            <v-label v-else-if="tables.mf_info.SelectedData.train_dt!==null">等待訓練完成</v-label>
                            <v-label v-else-if="tables.mf_info.SelectedData.collect_dt!==null">等待收集完成</v-label>
                            <v-label v-else>狀態異常</v-label>
                        </div>

                        <div class="ml-2 pa-2" style="width:400px; font-size:1.3em; font-weight: bolder;" >
                            <label v-if="tables.mf_info.SelectedData.collect_dt!==null">開始收集：{{tables.mf_info.SelectedData.collect_dt}}<br/></label>
                            <label v-if="tables.mf_info.SelectedData.train_dt!==null">開始訓練：{{tables.mf_info.SelectedData.train_dt}}<br/></label>
                            <label v-if="tables.mf_info.SelectedData.publish_dt!==null">開始更新{{tables.mf_info.SelectedData.publish_dt}}<br/></label>
                            <label v-if="tables.mf_info.SelectedData.uploaded_dt!==null">推送模型：{{tables.mf_info.SelectedData.uploaded_dt}}<br/></label>
                            <label v-if="tables.mf_info.SelectedData.finish_dt!==null">完成更新：{{tables.mf_info.SelectedData.finish_dt}}<br/></label>
                            <label v-if="tables.mf_info.SelectedData.cancel_dt!==null">取消日期：{{tables.mf_info.SelectedData.cancel_dt}}</label>
                        </div>
                    </div>
                    <div class="rowDiv contentCenter mt-5">
                        <div style="width:200px">
                            <v-text-field
                                label="模型名稱/版本"
                                v-model="tables.mf_info.SelectedData.model_verson_name"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                :disabled="tables.mf_info.SelectedData.train_dt!==null"
                            ></v-text-field>
                            <br/>                  
                            <v-switch class="pt-0 mt-0"
                                v-show="parseInt(tables.mf_info.SelectedData.status) <= 2"
                                v-model="tables.mf_info.SelectedData.switch_to_cancel" :true-value="true" :false-value="false" label="取消訓練"></v-switch>
                        </div>
                        <div style="width:400px" class="ml-2">
                            <v-textarea
                                label="備註"
                                v-model="tables.mf_info.SelectedData.remark"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                rows="3"
                                :disabled="tables.mf_info.SelectedData.train_dt!==null"
                            ></v-textarea>
                        </div>
                    </div>
                    <div class="rowDiv contentCenter mt-5 " v-if="tables.mf_info.SelectedData.switch_to_cancel">
                        <div class="warning" style="width:600px; text-align:center; color:white;">
                            只儲存修改為取消訓練
                        </div>
                    </div>
                    </v-form>
                </div>
                </v-card-text>
                <v-card-actions>
                <v-btn class="dialogbtn cancelBtnColor" @click="closeMFDialog">關閉</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="dialogbtn subBtnColor" @click="saveMFData">確認</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- 裝置清單進行資料採集 dialog 特製-->
        <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.sd_info.dialogAdd" persistent>
            <v-card>
                <v-card-title class="headline justify-center font-weight-bold">建立資料收集</v-card-title>
                <div class="contentCenter">
                    <v-btn-toggle
                        v-model="collectTab"
                        mandatory
                    >
                        <v-btn value="basicInfo" class="btn_fontSize">模型資訊</v-btn>
                        <v-btn value="eEventInfo" class="btn_fontSize">選擇圖片</v-btn>
                    </v-btn-toggle>
                </div>
                <div v-show="collectTab==='basicInfo'" class="mt-5" style="min-height: 400px">
                    <v-form ref="newModelCollecting">
                        <div class="rowDiv contentCenter">
                            <div style="width:200px">
                            <v-text-field
                                label="標的物編號"
                                v-model="tables.sd_info.SelectedData.site_id"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                            </div>
                            <div style="width:400px" class="ml-2">
                            <v-text-field
                                label="標的物名稱"
                                v-model="tables.sd_info.SelectedData.site_nm"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                            </div>
                        </div>
                        <div class="rowDiv contentCenter mt-5">
                            <div style="width:200px">
                            <v-text-field
                                label="設備MAC"
                                v-model="tables.sd_info.SelectedData.device_mac"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                disabled
                            ></v-text-field>
                            </div>
                            <div style="width:400px" class="ml-2">
                            <v-text-field
                                label="設備編號"
                                v-model="tables.sd_info.SelectedData.device_id"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                            </div>
                        </div>
                        <div class="rowDiv contentCenter mt-5">
                            <div style="width:200px">
                                <v-text-field
                                    label="頻道"
                                    v-model="tables.sd_info.SelectedData.channel"
                                    class="rounded-lg"
                                    dense
                                    outlined
                                    hide-details
                                    disabled
                                ></v-text-field>
                            </div>
                            <div style="width:400px" class="ml-2">
                                <v-text-field
                                    label="設備名稱"
                                    v-model="tables.sd_info.SelectedData.device_nm"
                                    class="rounded-lg"
                                    dense
                                    outlined
                                    hide-details
                                    :rules="rules.content"
                                    disabled
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="rowDiv contentCenter mt-5"></div>
                        <div class="rowDiv contentCenter mt-5">
                            <div style="width:200px">
                            <v-text-field
                                label="模型名稱/版本"
                                v-model="tables.sd_info.SelectedData.model_verson_name"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                            ></v-text-field>
                            </div>
                            <div style="width:400px" class="ml-2">
                            <v-textarea
                                label="備註"
                                v-model="tables.sd_info.SelectedData.remark"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                rows="3"
                            ></v-textarea>
                            </div>
                        </div>
                        <div class="rowDiv contentCenter mt-5"></div>
                    </v-form>
                </div>
                <div v-show="collectTab==='eEventInfo'" class="mt-5" style="min-height: 400px">
                    <div class="rowDiv contentCenter ma-0">

                        <v-radio-group v-model="tables.sd_info.SelectedData.status" class="ml-5" row dense hide-details>
                            <v-radio label="定時背景擷取" value="1" style="font-weight:bold;"></v-radio>
                            <v-radio :label="tables.ee_info.title" value="2" style="font-weight:bold;"></v-radio>
                        </v-radio-group>
                    </div>
                    <v-form ref="newBackCollecting" class="ma-5" v-if="tables.sd_info.SelectedData.status=='1'">
                        <div class="rowDiv contentCenter">
                            <div style="width:160px">
                            <v-text-field
                                label="收集間隔(hr)"
                                v-model="tables.sd_info.SelectedData.collect_hr"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                disabled
                            ></v-text-field>
                            </div>
                            <div style="width:160px" class="ml-2">
                            <v-text-field
                                label="收集張數"
                                v-model="tables.sd_info.SelectedData.collect_num"
                                class="rounded-lg"
                                dense
                                outlined
                                hide-details
                                :rules="rules.content"
                                type="number"
                                disabled
                            ></v-text-field>
                            </div>
                        </div>
                    </v-form>
                    <div class="rowDiv contentCenter pa-0 mt-2" v-if="tables.sd_info.SelectedData.status=='2'">
                        <v-toolbar-title class="ml-2" style="font-weight:bold;"></v-toolbar-title>
                        <div></div>
                        <div v-show="this.IsAdmin">
                            <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="() => {this.$refs.fileUpload.click(); }">上傳圖片</v-btn>
                            <input type="file" accept="image/*" style="display: none;" ref="fileUpload" @change="getFile">
                        </div>

                        <v-spacer>
                        </v-spacer>
                        <div class="text-center mr-5">
                            <v-pagination
                                circle
                                v-model="tables.ee_info.page"
                                :length="tables.ee_info.pageCount"
                                total-visible=7
                            ></v-pagination>
                        </div>
                        <v-divider
                        class="tableDivider mr-5"
                        vertical
                        inset
                        >
                        </v-divider>
                        <div class="text-center mr-5 contentCenter">共{{tables.ee_info.total}}筆</div>
                        <!-- 每頁顯示筆數 -->
                        <div style="width:180px">
                            <v-select
                                :items="tables.ee_info.rowsList"
                                outlined
                                class="rounded-lg"
                                dense
                                v-model="tables.ee_info.rows"
                                hide-details
                                prefix="每頁顯示"
                                suffix="筆"
                            >
                            </v-select>
                        </div>
                    </div>
                    <div v-if="tables.sd_info.SelectedData.status=='2'">
                        <v-data-table
                            class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
                            hide-default-footer
                            :items="tables.ee_info.data"
                            :headers="tables.ee_info.headers"
                            hide-default-header
                            v-if="tables.ee_info"
                            height="400"
                            fixed-header
                            :loading="tables.ee_info.isLoading"
                        >
                            <template v-slot:header>
                                <thead>
                                <tr>
                                    <th
                                        class="greyTh"
                                        v-for="header in tables.ee_info.headers"
                                        :key="header.value"
                                    >
                                    <div
                                        :style="'width:'+header.width+'px'"
                                        @click="changeSort(header, tables.ee_info)"
                                        class="sortableThDiv"
                                    >
                                        <div class="sortableThDivText">{{header.text}}</div>
                                        <div v-if="header.sortable&&tables.ee_info.sortItem===header.value">
                                            <v-icon v-if="tables.ee_info.sortOrder">mdi-chevron-down</v-icon>
                                            <v-icon v-else>mdi-chevron-up</v-icon>
                                        </div>
                                    </div>
                                    </th>
                                </tr>
                                </thead>
                            </template>
                            <template v-slot:item="{ item }">
                                <tr>
                                <td v-for="header in tables.ee_info.headers"
                                    :key="header.value"
                                    class="tableTD"
                                >
                                    <div v-if ="header.value === 'PicUrl'">
                                        <img width="200px" height="112px"
                                            v-show="item[header.value].length > 0"
                                            :src="item.B64PicUrl"
                                            :style="tables.sd_info.SelectedData.UploadedUrl.indexOf(item[header.value]) >= 0 ? 'border: 3px dashed red' : 'border: 3px solid white'"
                                            @click="PicUrlClick(item, header.value, item[header.value])" />
                                        <span v-show="item[header.value].length === 0">-</span>
                                    </div>
                                    <div v-else>{{item[header.value]}}</div>
                                </td>
                                </tr>
                            </template>
                            <template v-slot:no-data>
                                no data available
                            </template>
                        </v-data-table>
                        <div v-if="tables.sd_info.SelectedData.UploadedUrl.length === 0"
                            class="rowDiv contentCenter d-flex flex-row" 
                            style="max-width:900px;overflow-x: scroll;">
                            <div style="height:80px" class="mt-10" justify="center">請選擇誤報圖片或上傳圖片，最少 {{imageSelectionNum}} 張</div>
                        </div>
                        <div v-else 
                            style="max-width:900px;overflow-x: scroll;" class="d-flex flex-row">
                            <div v-for="(item, i) in tables.sd_info.SelectedData.UploadedUrl"
                                :key="i">
                                <v-expand-x-transition>
                                <v-img 
                                    class="text-right ma-1"
                                    width="200"
                                    height="112"
                                    :src="ShowImage(item)"
                                    @click="PicUrlClick({}, '', item)"
                                    :style="tables.sd_info.imgCache.find(o=>o.PicUrl === item).EventTime === 'Upload' ? 'border: 3px dashed green' : 'border: 3px dashed red'"
                                    cover
                                ><span style="text-shadow: 1px 1px 2px red, 0 0 1em blue, 0 0 0.2em blue;">{{tables.sd_info.imgCache.find(o=>o.PicUrl === item).EventTime}}</span></v-img>
                                </v-expand-x-transition>
                            </div>
                        </div>
                    </div>
                </div>

                <v-card-actions>
                <v-btn class="dialogbtn cancelBtnColor" @click="closeSDDialog">關閉</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="dialogbtn subBtnColor" @click="saveSDData" v-show="this.IsDialogReady">確認</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</v-container>
</template>
<script>
import Service from '../service/service'
export default {
    name: 'Mode_Flow_Info',
    data: () => ({
        tables: {
            mf_info: {
                isLoading: false,
                urlGet: 'model_flow_info/getPageData',
                urlAdd: '',
                urlUpdate: 'model_flow_info/Update',
                title: '模型控制',
                headers: [
                    { text: '訓練流水號', value: 'collect_dt', sortable: false },
                    { text: '標的物名稱', value: 'site_nm', sortable: false },
                    { text: '標的物編號', value: 'site_id', sortable: false },
                    { text: '設備編號', value: 'device_id', sortable: false },
                    { text: '設備MAC', value: 'device_mac', sortable: false },
                    { text: '頻道', value: 'channel', sortable: false },
                    { text: '設備名稱', value: 'device_nm', sortable: false },
                    { text: '狀態', value: 'status',  sortable: false },

                    { text: '模型名稱/版本', value: 'model_verson_name',  sortable: false },
                    { text: '模型檔案名稱', value: 'model_file_name',  sortable: false },
                    { text: '備註', value: 'remark',  sortable: false },
                    // { text: '訓練時間	', value: 'train_dt',  sortable: false },
                    // { text: '發布時間', value: 'publish_dt',  sortable: false }
                    // { text: '上傳時間', value: 'uploaded_dt',  sortable: false }
                    // { text: '更新時間', value: 'finlish_dt',  sortable: false }
                ],
                rows: 10,
                sortItem: '',
                sortOrder: true,
                pageCount: 0,
                page: 1,
                total: 0,
                rowsList: [10, 20, 30, 40, 50],
                search: {
                    mode: {
                        name: 'Mode',
                        value: 'MFList',
                        displayType: '='
                    },
                    site_id: {
                        name: 'site_id',
                        value: '',
                        displayType: 'like'
                    },
                    device_id: {
                        name: 'device_id',
                        value: '',
                        displayType: 'like'
                    },
                    device_mac: {
                        name: 'device_mac',
                        value: '',
                        displayType: 'like'
                    },
                    status: {
                        name: 'status',
                        value: '',
                        displayType: '='
                    }
                },
                data: [],
                SelectedData: { 
                    seqno: 0, site_id: '', device_id: '', device_mac: '', channel: '', status: 0, model_verson_name: '', remark: '', extra: ' ', 
                    train_dt: '', publish_dt: '', uploaded_dt: '', finish_dt: '',cancel_dt: '',
                    switch_to_cancel: false
                },
                dialogAdd: false,
            },
            sd_info: {
                isLoading: false,
                urlGet: 'model_flow_info/getPageData',
                urlAdd: 'model_flow_info/Add',
                urlUpdate: 'model_flow_info/Update',
                title: '設備清單',
                headers: [
                    { text: '標的物名稱', value: 'site_nm', sortable: false },
                    { text: '標的物編號	', value: 'site_id', sortable: false },
                    { text: '設備編號', value: 'device_id', sortable: false },
                    { text: '設備MAC', value: 'device_mac', sortable: false },
                    { text: '設備廠商', value: 'device_kind', sortable: false },
                    { text: '頻道', value: 'channel', sortable: false },
                    { text: '設備名稱', value: 'device_nm', sortable: false },
                    { text: '狀態', value: 'status', sortable: false },
                    { text: '功能', value: 'func', sortable: false },
                ],
                rows: 10,
                sortItem: '',
                sortOrder: false,
                pageCount: 0,
                page: 1,
                total: 0,
                rowsList: [10, 20, 30, 40, 50],
                search: {
                    mode: {
                        name: 'Mode',
                        value: 'SDList',
                        displayType: '='
                    },
                    site_id: {
                        name: 'site_id',
                        value: '',
                        displayType: 'like'
                    },
                    device_id: {
                        name: 'device_id',
                        value: '',
                        displayType: 'like'
                    },
                    device_mac: {
                        name: 'device_mac',
                        value: '',
                        displayType: 'like'
                    },
                    status: {
                        name: 'status',
                        value: '',
                        displayType: '='
                    }
                },
                data: [],
                SelectedData: { site_id: '', site_nm: '', device_id: '', device_mac: '', device_kind: '', device_p2pid: '', channel: '', device_nm: '', status: '2', model_file_name: '', model_verson_name: '', remark: '', UploadedUrl: [], collect_num:4,collect_hr: '00,06,12,18',  },
                imgCache: [],
                dialogAdd: false,
            },

            ee_info: {
                isLoading: false,
                urlGet: 'model_flow_info/getPageData',
                urlAdd: '',
                urlUpdate: '',
                urlPic: 'model_flow_info/GetEventPic',
                urlUpload: 'model_flow_info/Upload',
                title: '誤報/上傳圖片',
                headers: [
                    { text: '誤報時間', value: 'EventTime', sortable: false },
                    { text: '截圖', value: 'PicUrl', sortable: false }
                ],
                rows: 10,
                sortItem: '',
                sortOrder: false,
                pageCount: 0,
                page: 1,
                total: 0,
                rowsList: [10, 20, 30, 40, 50],
                search: {
                    mode: {
                        name: 'Mode',
                        value: 'EEList',
                        displayType: '='
                    },
                    site_id: {
                        name: 'site_id',
                        value: '',
                        displayType: '='
                    },
                    device_id: {
                        name: 'device_id',
                        value: '',
                        displayType: '='
                    }
                },
                data: [],
                SelectedData: {},
                dialogAdd: false,
            }
        },
        rules: {
            content: [v => !!v || 'Required']
        },
        sidebar: {
            open: true, 
            width: 260,
            icon: 'mdi-arrow-expand-left',
            iconClass: 'mr-5',
        },
        imageSelectionNum: 4,
        collectTab: 'basicInfo',
        status_dic: [{'key':-1,'value':'取消'}, {'key':1,'value':'收集中'}, {'key':2,'value':'訓練中'}, {'key':3,'value':'發佈中'}, {'key':4,'value':'上傳中'}, {'key':5,'value':'已更新'}],
        status_dic_2: [{'key':-1,'value':'取消'}, {'key':0,'value':'-'}, {'key':1,'value':'收集中'}, {'key':2,'value':'訓練中'}, {'key':3,'value':'發佈中'}, {'key':4,'value':'上傳中'}, {'key':5,'value':'已更新'}],
        site_dic: [],

        controlPermission: [],

    }),
    computed: {
        IsAdmin: function () {
            return this.user.funcLoader.indexOf('FUNC_CTRL_MFI') >= 0
        },
        IsDialogReady: function() {
            if (this.tables.sd_info.SelectedData.status == '2'
            && this.tables.sd_info.SelectedData.UploadedUrl.length >= this.imageSelectionNum)
                return true;
            // console.log(this.tables.sd_info.SelectedData.status,this.tables.sd_info.SelectedData.UploadedUrl)
            if (this.tables.sd_info.SelectedData.status == '1'
            && this.tables.sd_info.SelectedData.collect_hr.length > 0
            && this.tables.sd_info.SelectedData.collect_num > 0)
                return true;
            // console.log(this.tables.sd_info.SelectedData.status,this.tables.sd_info.SelectedData.collect_hr,this.tables.sd_info.SelectedData.collect_num)
            return false
        }
    },
    watch: {
        'sidebar.open' () {
            this.sidebar.width = this.sidebar.open ? 260 : 0
            this.sidebar.icon = this.sidebar.open ? 'mdi-arrow-expand-left' : 'mdi-tune-variant'
            // this.sidebar.iconClass = this.sidebar.open ? 'mr-5' : 'mr-5 my-5'
        },
        'tables.mf_info.search.site_id.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                this.getPageData(this.tables.mf_info)
            }
        },
        'tables.mf_info.search.device_id.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.mf_info) }
            }
        },
        'tables.mf_info.search.device_mac.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.mf_info) }
            }
        },
        'tables.mf_info.search.status.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.mf_info) }
            }
        },

        'tables.sd_info.search.site_id.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.sd_info) }
            }
        },
        'tables.sd_info.search.device_id.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.sd_info) }
            }
        },
        'tables.sd_info.search.device_mac.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.sd_info) }
            }
        },
        'tables.sd_info.search.status.value' : {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.sd_info) }
            }
        },
        'tables.mf_info.page': {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.mf_info) }
            }
        },
        'tables.mf_info.rows': {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.mf_info) }
            }
        },
        'tables.sd_info.page': {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.sd_info) }
            }
        },
        'tables.sd_info.rows': {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { this.getPageData(this.tables.sd_info) }
            }
        },
        'tables.ee_info.page': {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { 
                    this.getPageData(this.tables.ee_info, (table) => {
                        table.data.forEach(row => {
                            this.GetEventPic(row, 'AlarmID')
                        });
                    })
                }
            }
        },
        'tables.ee_info.rows': {
            immediate: true,
            handler: function (nvalue, ovalue) {
                if (ovalue === undefined) return
                if (nvalue !== ovalue) { 
                    if (ovalue === undefined) return
                    this.getPageData(this.tables.ee_info, (table) => {
                        table.data.forEach(row => {
                            this.GetEventPic(row, 'AlarmID')
                        });
                    }) 
                }
            }
        },
    },
    created: function () {
        this.$emit('setAppbar', { isHide: false })
    },
    mounted: function () {
        // this.path = this.$router.currentRoute.path
        // const control = this.permissions.find(x => x.path === this.path)
        // this.controlPermission = control ? control.permission : []
        this.getPageData(this.tables.mf_info)
        this.getPageData(this.tables.sd_info)
    },
    destroyed: function() {
    },
    props: {
        user: null,
        permissions: null,
        isMobile: null
    },
  methods: {
    showAlert (type, message) {
        var alert = {
            alertType: null,
            alertMessage: '',
            alertIcon: null
        }
        if (type === 'success') {
            alert.alertType = 'success'
            alert.alertIcon = 'mdi-check-circle'
        } else {
            alert.alertType = 'error'
            alert.alertIcon = 'mdi-alert-circle'
        }
        alert.alertMessage = message
        this.$emit('setAlert', alert)
    },
    changeSort (header, table) {
        if (!header.sortable) return

        if (header.value === table.sortItem) {
            table.sortOrder = !table.sortOrder
        } else {
            table.sortOrder = true
            table.sortItem = header.value
        }
        this.getPageData(table)
    },
    GetStatusExtensionDesc (item) {
        var dt = ''
        switch(item.status) {
            case -1: dt = item.cancel_dt; break
            case 1: dt = item.collect_dt; break
            case 2: dt = item.train_dt; break
            case 3: dt = item.publish_dt; break
            case 4: dt = item.uploaded_dt; break
            case 5: dt = item.finish_dt; break
            default: dt = ''
        }

        var item2 = this.status_dic.find(o=>o.key === item.status);
        return item2.value + '\r\n(' + dt + ')'
    },
    GetStatusIcon (item) {
        switch(item.status) {
            case -1:return 'mdi-account-cancel'
            case 0: return ''
            case 1: return 'mdi-camera-plus'
            case 2: return 'mdi-memory'
            case 3: return 'mdi-publish'
            case 4: return 'mdi-camera-wireless'
            case 5: return 'mdi-cloud-check-variant'
            default: return 'mdi-comment-question-outline'
        }
    },
    getPageData (table, callback) {
        table.isLoading = true
        var wheres = []//[search_mode, search_site_id, search_device_id, search_device_mac, search_status]
        for (var variable in table.search)
        {
            wheres.push(table.search[variable])
        }
        var parm = {
            page: table.page,
            rows: table.rows,
            order: table.sortOrder ? 'desc' : 'asc',
            sort: table.sortItem,
            wheres: JSON.stringify(wheres),
            url: table.urlGet
        }
        Service.getPageData(parm)
            .then((response) => {
                // console.log(response)
                if (response.status !== 200 || response.data.status !== 0) {
                    this.showAlert('error', response.data.message)
                } else {
                    table.total = response.data.total
                    table.pageCount = Math.ceil(table.total / table.rows)

                    table.data = response.data.rows

                    if (callback) callback(table)
                }
            })
        .finally(() => {
            table.isLoading = false
        })
    },
    
    openMFDialog (item) {
        this.tables.mf_info.dialogAdd = true

        this.tables.mf_info.SelectedData.seqno = item.seqno
        this.tables.mf_info.SelectedData.site_id = item.site_id
        this.tables.mf_info.SelectedData.site_nm = item.site_nm
        this.tables.mf_info.SelectedData.device_id = item.device_id
        this.tables.mf_info.SelectedData.device_nm = item.device_nm
        this.tables.mf_info.SelectedData.device_mac = item.device_mac
        this.tables.mf_info.SelectedData.device_kind = item.device_kind
        this.tables.mf_info.SelectedData.channel = item.channel
        this.tables.mf_info.SelectedData.status = item.status
        this.tables.mf_info.SelectedData.model_verson_name = item.model_verson_name
        this.tables.mf_info.SelectedData.remark = item.remark
        this.tables.mf_info.SelectedData.extra = item.extra

        this.tables.mf_info.SelectedData.collect_dt = item.collect_dt
        this.tables.mf_info.SelectedData.train_dt = item.train_dt
        this.tables.mf_info.SelectedData.publish_dt = item.publish_dt
        this.tables.mf_info.SelectedData.uploaded_dt = item.uploaded_dt
        this.tables.mf_info.SelectedData.finish_dt = item.finish_dt
        this.tables.mf_info.SelectedData.cancel_dt = item.cancel_dt

        this.tables.mf_info.SelectedData.switch_to_cancel = item.switch_to_cancel
    },
    closeMFDialog () {
        this.tables.mf_info.dialogAdd = false
        this.$refs.ModelManagement.resetValidation()
    },
    saveMFData () {
        if (this.$refs.ModelManagement.validate()) {
            Service.updateData(this.tables.mf_info.SelectedData, this.tables.mf_info.urlUpdate)
            .then((response) => {
                // console.log(response)
                if (response.status !== 200 || !response.data.status) {
                    this.showAlert('error', response.data.message)
                } else {
                    this.showAlert('success', response.data.message)
                    
                    this.getPageData(this.tables.mf_info)
                    this.closeMFDialog()
                }
                this.tables.mf_info.dialogAdd = false
            })
        } else {
            this.showAlert('error', 'validate fail')
        }
    },
    closeSDDialog () {
        this.collectTab = 'basicInfo'
        this.tables.sd_info.imgCache.splice(0)
        this.tables.sd_info.SelectedData.UploadedUrl.splice(0)

        this.tables.sd_info.dialogAdd = false
        this.$refs.newModelCollecting.resetValidation()
    },
    saveSDData () {
        if (this.$refs.newModelCollecting.validate()) {
            // 調整傳遞參數
            let cpy = JSON.parse(JSON.stringify(this.tables.sd_info.SelectedData))
            for(let _key in cpy.UploadedUrl) {
                let Url = cpy.UploadedUrl[_key]
                let EventID = '', Key = '', EventTime = ''
                this.tables.sd_info.imgCache.forEach(cache => {
                    if (cache.PicUrl == Url) {
                        EventID = cache.EventID
                        EventTime = cache.EventTime
                        Key = 'PicUrl'
                    }
                })
                cpy.UploadedUrl[_key] = { EventID, Key, Url, EventTime }
            }
            
            cpy.UploadedUrl = JSON.stringify(cpy.UploadedUrl)
            Service.updateData(cpy, this.tables.sd_info.urlAdd)
            .then((response) => {
                // console.log(response)
                if (response.status !== 200 || !response.data.status) {
                    this.showAlert('error', response.data.message)
                } else {
                    this.showAlert('success', response.data.message)
                    // 
                    this.getPageData(this.tables.sd_info)
                    this.getPageData(this.tables.mf_info)
                    this.closeSDDialog()
                    //this.$forceUpdate()
                }

                this.tables.sd_info.dialogAdd = false
            })
        } else {
            this.showAlert('error', 'validate fail')
        }
    },
    openSDDialog (item) {
        this.tables.ee_info.search.site_id.value = item.site_id
        this.tables.ee_info.search.device_id.value = item.device_id
        this.getPageData(this.tables.ee_info, (table) => {
            table.data.forEach(row => {
                this.GetEventPic(row, 'AlarmID')
            });
        })

        this.tables.sd_info.dialogAdd = true

        this.tables.sd_info.SelectedData.site_id = item.site_id
        this.tables.sd_info.SelectedData.site_nm = item.site_nm
        this.tables.sd_info.SelectedData.device_id = item.device_id
        this.tables.sd_info.SelectedData.device_nm = item.device_nm
        this.tables.sd_info.SelectedData.device_mac = item.device_mac
        this.tables.sd_info.SelectedData.device_kind = item.device_kind
        this.tables.sd_info.SelectedData.device_p2pid = item.device_p2pid
        this.tables.sd_info.SelectedData.channel = item.channel
        this.tables.sd_info.SelectedData.model_file_name = ''
        this.tables.sd_info.SelectedData.model_verson_name = ''
        this.tables.sd_info.SelectedData.remark = ''
        this.tables.sd_info.SelectedData.UploadedUrl.splice(0)
    },
    reset_search_mf_info () {
        this.tables.mf_info.search.site_id.value = ''
        this.tables.mf_info.search.device_id.value = ''
        this.tables.mf_info.search.device_mac.value = ''
        this.tables.mf_info.search.status.value = ''
    },
    reset_search_sd_info () {
        this.tables.sd_info.search.site_id.value = ''
        this.tables.sd_info.search.device_id.value = ''
        this.tables.sd_info.search.device_mac.value = ''
        this.tables.sd_info.search.status.value = ''
    },

    GetEventPic (item, key) {
        let alarmID = item[key]
        Service.updateData({ alarmID: alarmID, width:400, height:225}, this.tables.ee_info.urlPic)
            .then((response) => {
                if (response.status !== 200 || !response.data.status) {
                    item.B64PicUrl = ''
                } else {
                    item.B64PicUrl = "data:image/jpeg;base64," + response.data.data + ""
                }
            })
    },
    ShowImage(item) {
        var target = this.tables.sd_info.imgCache.find(o=>o.PicUrl === item)
        if (target.EventTime === 'Upload') {
            return target.B64PicUrl
        } else {
            return target.B64PicUrl
        }
    },
    PicUrlClick (item, key, PicUrl) {
        const uIndex = this.tables.sd_info.SelectedData.UploadedUrl.indexOf(PicUrl)
        if(uIndex >= 0) {
            this.tables.sd_info.SelectedData.UploadedUrl.splice(uIndex, 1)

            const idx = this.tables.sd_info.imgCache.findIndex(o=>o.PicUrl === PicUrl)
            this.tables.sd_info.imgCache.splice(idx, 1)
        } else {
            this.tables.sd_info.SelectedData.UploadedUrl.push(PicUrl)
            this.tables.sd_info.imgCache.push({ 
                PicUrl: PicUrl, 
                B64PicUrl: item.B64PicUrl, 
                EventTime: item.EventTime, 
                EventID: item.EventID, 
                key: key })
        }
    },
    getFile (event) {
        this.excLoading = true
        const file = event.target.files
        if (file.length == 0) return
        this.photoImg = file[0]
        this.uploadImg = new FormData()
        this.uploadImg.append('fileInput', file[0], file[0].name)

        Service.uploadFile(this.uploadImg, this.tables.ee_info.urlUpload)
            .then((response) => {
                // console.log(response)
                if (response.status !== 200 || !response.data.status) {
                    this.showAlert('error', response.data.message)
                } else {
                    const url = process.env.VUE_APP_API_URL1 + '/' + response.data.data + file[0].name
                    
                    this.tables.sd_info.SelectedData.UploadedUrl.push(url)
                    this.tables.sd_info.imgCache.push({ PicUrl: url, B64PicUrl: url, EventTime: 'Upload', EventID: 'Upload', key: 'Upload' })
                }
            })
    },
  }
}
</script>
<style scoped>

</style>
